import React, { useEffect, useContext } from 'react'
import AuthContext from './AuthContext';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router';
import { routesWithTitleSync } from '../config/routeConfig';

type Props = {
    children?: React.ReactNode;
}

const TitleContext = (props: Props) => {
    const { t } = useTranslation();
    const { userInfo } = useContext(AuthContext);
    let location = useLocation()


    useEffect(() => {
        const matchingPath = getMatchingPath();
        let restaurantName = userInfo?.selected_restaurant?.name;
        let newTitle = matchingPath != null ? t("common.titles.main_title") + " - " + t(`common.titles.${matchingPath.title}`) : t("common.titles.main_title");
        if (restaurantName) {
            newTitle += ` - ${restaurantName}`;
        }
        document.title = newTitle;
    }, [location, t, userInfo])

    function getMatchingPath() {
        return routesWithTitleSync.find(route => matchPath(route.path, location.pathname) != null)
    }

    return (
        <>
            {props.children}
        </>
    )
}

export default TitleContext